module.exports = __webpack_public_path__ + "static/ha9-a0d7a9de535ac3933d9837c1af44a7a7.jpg";